import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem('ef_theme') || 'light';
    } catch {
      return 'light';
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('ef_theme', theme);
    } catch (e) {
      console.debug('localStorage set failed', e);
    }
    const el = document.documentElement || document.body;
    const isDark = theme === 'dark';
    // Interop: BeatLogic uses .theme-dark; shared UI uses .dark
    el.classList.toggle('theme-dark', isDark);
    el.classList.toggle('theme-light', !isDark);
    el.classList.toggle('dark', isDark);
    el.dataset.theme = theme;
  }, [theme]);

  const toggle = () => setTheme((t) => (t === 'light' ? 'dark' : 'light'));

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;

ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
